// Registration is embedded on-site via the official Bloomerang widget
// (see WIDGET_SRC in src/components/RegisterWidget.jsx).

export const LOGO_URL =
  "https://customer-assets-4nw71qhi.emergentagent.net/job_6cb144ea-c4ce-4746-8972-dc8968400204/artifacts/6p3co9qb_Logos.png";

export const CEO_URL =
  "https://customer-assets-jt897jd0.emergentagent.net/job_fundraiser-run-walk/artifacts/t6qoib7c_Logos%20(1).png";

export const EVENT = {
  name: "2Run4Hope",
  org: "Hope Restored Missions",
  date: "Saturday, November 21, 2026",
  shortDate: "SAT 11.21.26",
  time: "7:00 AM",
  startIso: "2026-11-21T08:00:00-06:00",
  venue: "Celebration Park",
  address: "701 North Angel Parkway, Allen, TX 75002",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1683194381604-b0f7ee52584a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxibGFjayUyMGhpc3BhbmljJTIwb2xkZXIlMjB3aGl0ZSUyMHJ1bm5pbmclMjBncm91cHxlbnwwfHx8fDE3OTA5Njg5MDR8MA&ixlib=rb-4.1.0&q=85&w=1920",
  family:
    "https://images.unsplash.com/photo-1588979355313-6711a095465f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxkaWduaWZpZWQlMjBob3BlZnVsJTIwZmFtaWx5JTIwcG9ydHJhaXR8ZW58MHx8fHwxNzkwOTY1MDQ4fDA&ixlib=rb-4.1.0&q=85",
  hands:
    "https://images.unsplash.com/photo-1513193563746-fac77a988f8d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxoYW5kcyUyMGhvbGRpbmclMjBoZWFydCUyMHdhcm18ZW58MHx8fHwxNzkwOTY1MDQ4fDA&ixlib=rb-4.1.0&q=85",
  volunteers:
    "https://images.unsplash.com/photo-1559027615-cd4628902d4a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHx2b2x1bnRlZXJzJTIwY29tbXVuaXR5JTIwZXZlbnQlMjBqb3l8ZW58MHx8fHwxNzkwOTY1MDQ4fDA&ixlib=rb-4.1.0&q=85",
};
